module.exports = __webpack_public_path__ + "static/media/news-teletherapy-session.2967fd30.jpg";